import React, { FC, useState, useCallback } from 'react';
import EllipsisTooltip from '@common/ellipsisTooltip';

import classnames from 'classnames/bind';
import styles from './ellipsisText.module.scss';
const cx = classnames.bind(styles);

interface EllipsisTextProps {
  text: string;
  type: 'width' | 'height';
  offset: number;
  customClassName: string;
  tooltipType?: 'top' | '';
}

// TODO: 말줄임 텍스트 공통화 작업 추후 진행 예정
const EllipsisText: FC<EllipsisTextProps> = ({ text, type, offset, customClassName, tooltipType }) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const textOffset = offset;
  const [isTooltipHover, setIsTooltipHover] = useState(false);

  const textRef = useCallback((node: HTMLElement) => {
    if (node !== null) {
      if (type === 'width') {
        setIsTooltipVisible(node.offsetWidth > textOffset);
      } else {
        setIsTooltipVisible(node.offsetHeight > textOffset);
      }
    }
  }, []);

  let timeoutId: NodeJS.Timeout;

  const handleMouseEnter = () => {
    timeoutId = setTimeout(() => setIsTooltipHover(true), 1000);
  };

  const handleMouseLeave = () => {
    setIsTooltipHover(false);
    clearTimeout(timeoutId);
  };

  return (
    <div className={cx('ellipsisTextArea')} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className={cx('ellipsisTextWrap', customClassName)}>
        <span className={cx('ellipsisText')} ref={textRef}>
          {text}
        </span>
      </div>

      {isTooltipVisible && isTooltipHover && <EllipsisTooltip text={text} type={tooltipType} />}
    </div>
  );
};

export default EllipsisText;
